export default {"src":"/frontend-static/_next/static/media/clearpay_badge.77b354d9.svg","height":106,"width":166,"blurWidth":0,"blurHeight":0};